import { load } from '@cashfreepayments/cashfree-js';

let cashfreePromise = null;

export const getCashfreeMode = () =>
  process.env.REACT_APP_CF_ENV === 'production' ? 'production' : 'sandbox';

export const loadCashfree = () => {
  if (!cashfreePromise) {
    cashfreePromise = load({ mode: getCashfreeMode() });
  }
  return cashfreePromise;
};

export const openCashfreeCheckout = async ({
  paymentSessionId,
  redirectTarget = '_modal',
  returnUrl,
}) => {
  const cashfree = await loadCashfree();
  return cashfree.checkout({
    paymentSessionId,
    redirectTarget,
    ...(returnUrl ? { returnUrl } : {}),
  });
};

/** Open Cashfree hosted subscription checkout from the create-subscription response. */
export const openCashfreeSubscription = async ({
  paymentLink,
  subscriptionSessionId,
}) => {
  if (paymentLink) {
    window.location.href = paymentLink;
    return;
  }

  if (!subscriptionSessionId) {
    throw new Error("Cashfree did not return a subscription session ID.");
  }

  const cashfree = await loadCashfree();
  if (typeof cashfree?.subscriptionsCheckout !== "function") {
    throw new Error("Cashfree subscription checkout is unavailable in this SDK.");
  }

  const result = await cashfree.subscriptionsCheckout({
    subsSessionId: subscriptionSessionId,
    redirectTarget: "_self",
  });
  if (result?.error) {
    throw new Error(result.error.message || "Cashfree could not open subscription checkout.");
  }
  return result;
};

export const shouldVerifyCashfreePayment = (result) =>
  Boolean(result?.paymentDetails || result?.redirect);
